<div
  class="registration-layout"
  [ngStyle]="{ 'background-image': 'url(' + ('images/login-registration/login-background-image.jpg' | contentAssetImage) + ')' }"
>
  <img alt="imagedetails" [src]="'images/login-registration/loginpagelogo.png' | contentAssetImage" class="logo" />
  <div class="registration-container">
    <router-outlet></router-outlet>
  </div>
</div>
